import { useDispatch } from 'react-redux'
import { setPostsTypeStatus } from 'store'
import {
  FIRST_TAB_COLOR_INFO,
  SECOND_TAB_COLOR_INFO,
  THIRD_TAB_COLOR_INFO
} from 'utils/constants'
import {
  CustomBtn,
  CustomMainBox
} from './styled'

const blogTypes = [
  'archived',
  'scheduled',
  'posted'
]

export const PostTypes = ({ postsTypeStatus }) => {
  const dispatch = useDispatch()

  return (
    <CustomMainBox justifyContent="space-between">
      {
        blogTypes.map((blogType) => {
          let info = ''
          if (blogType === 'archived') {
            info = FIRST_TAB_COLOR_INFO
          } else if (blogType === 'scheduled') {
            info = SECOND_TAB_COLOR_INFO
          } else if (blogType === 'posted') {
            info = THIRD_TAB_COLOR_INFO
          }

          return (
            <CustomBtn
              initial={false}
              animate={{
                fontSize: postsTypeStatus === blogType ? '16px' : '14px',
                textShadow: postsTypeStatus === blogType ? '0 0 0 white' : '0 0 1.2px white',
                backgroundColor: info?.bgColor,
                '--tab-bg': info.bgColor
              }}
              whileHover={{
                textShadow: '0 0 0 white',
                backgroundColor: info?.bgColorHover,
                '--tab-bg': info?.bgColorHover
              }}
              transition={{
                type: 'tween',
                duration: 0.3
              }}
              pointerEvents={postsTypeStatus === blogType ? 'none' : 'auto'}
              onClick={() => dispatch(setPostsTypeStatus(blogType))}
              blogType={blogType}
            >
              {blogType.charAt(0).toUpperCase() + blogType.slice(1)}
            </CustomBtn>
          )
        })
      }
    </CustomMainBox>
  )
}
